"use strict";
import { Footer } from "components/Footer";
import { AGENT_PILL_CLEARANCE_PX, useReportFooterOverlap } from "features/agent/bottomDock";
import { Body } from "pages/App/Body";
import { Header } from "pages/App/Header";
import { GRID_AREAS } from "pages/App/utils/shared";
import { useRef } from "react";
import styled from "styled-components";
import { breakpoints } from "ui/src/theme";
const AppContainer = styled.div`
  min-height: 100vh;
  max-width: 100vw;
  position: relative;
  background-color: ${({ theme }) => theme.background};

  // grid container settings
  display: grid;
  grid-template-columns: 1fr;
  // MAIN takes the 1fr so the footer is pushed to the bottom of the viewport on
  // short pages rather than floating under the content.
  grid-template-rows: auto 1fr auto auto;
  grid-template-areas: '${GRID_AREAS.HEADER}' '${GRID_AREAS.MAIN}' '${GRID_AREAS.FOOTER}' '${GRID_AREAS.MOBILE_BOTTOM_BAR}';
`;
const AppFooter = styled.footer`
  grid-area: ${GRID_AREAS.FOOTER};
  width: 100%;
`;
const AppBody = styled.div`
  grid-area: ${GRID_AREAS.MAIN};
  width: 100vw;
  min-height: 100%;
  // Whitespace for the agent pill to land in, so a page scrolled to its end
  // never puts its last button under the pill. See AGENT_PILL_CLEARANCE_PX.
  padding-bottom: ${AGENT_PILL_CLEARANCE_PX}px;
  max-width: ${({ theme }) => `${theme.maxWidth}px`};
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: center;
  flex: 1;
  position: relative;
  margin: auto;

  @media screen and (max-width: ${breakpoints.md}px) {
    padding-left: 10px;
    padding-right: 10px;
  }
`;
export function AppLayout() {
  const footerRef = useRef(null);
  useReportFooterOverlap(footerRef);
  return <AppContainer>
      <Header />
      <AppBody>
        <Body />
      </AppBody>
      <AppFooter ref={footerRef}>
        <Footer />
      </AppFooter>
    </AppContainer>;
}
